import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import AcceptInvite from "@/views/AcceptInvite.vue";
import Home from "@/views/boarua/Home.vue";
import ProfileSelect from "@/views/boarua/ProfileSelect.vue";
import ResourceList from "@/views/boarua/ResourceList.vue";
import SecurityAlert from "@/views/boarua/SecurityAlert.vue";
import GatehouseAuthorization from "@/views/boarua/GatehouseAuthorization.vue";
import Packages from "@/views/boarua/Packages.vue";
import DailyServices from "@/views/boarua/DailyServices.vue";
import LocalBusinesses from "@/views/boarua/LocalBusinesses.vue";
import Polls from "@/views/boarua/Polls.vue";
import MonthlyReports from "@/views/boarua/MonthlyReports.vue";

const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  if (!token && to.path !== "/login") {
    next({ path: "/login" });
    return;
  }

  next();
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      { path: "/login", name: "login", component: Login },
      { path: "/aceitar-convite", name: "AcceptInvite", component: AcceptInvite },
      { path: "/", redirect: "/login" },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      { path: "/home", name: "Home", component: Home, beforeEnter: guard },
      { path: "/perfis", name: "Profiles", component: ProfileSelect, beforeEnter: guard },
      { path: "/seguranca", name: "SecurityAlert", component: SecurityAlert, beforeEnter: guard },
      { path: "/portaria", name: "GatehouseAuthorization", component: GatehouseAuthorization, beforeEnter: guard },
      { path: "/encomendas", name: "Packages", component: Packages, beforeEnter: guard },
      { path: "/servicos", name: "DailyServices", component: DailyServices, beforeEnter: guard },
      { path: "/comercio-local", name: "LocalBusinesses", component: LocalBusinesses, beforeEnter: guard },
      { path: "/votacoes", name: "Polls", component: Polls, beforeEnter: guard },
      { path: "/relatorios", name: "MonthlyReports", component: MonthlyReports, beforeEnter: guard },
      { path: "/demandas", name: "Demands", component: ResourceList, beforeEnter: guard, meta: { title: "Chamados", endpoint: "/demands" } },
      { path: "/financeiro", name: "Charges", component: ResourceList, beforeEnter: guard, meta: { title: "Financeiro", endpoint: "/monthly-charges" } },
      { path: "/assembleias", name: "Assemblies", component: ResourceList, beforeEnter: guard, meta: { title: "Assembleias", endpoint: "/assemblies" } },
      {
        path: "/feed",
        name: "Feed",
        component: ResourceList,
        beforeEnter: guard,
        meta: {
          title: "Feed",
          endpoint: "/feed-posts",
          fixedPostTypes: ["announcement", "improvement", "work", "accountability"],
        },
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
